export enum FilterTypeEnum { // when adding new type should be added for getFormattedValueByConfig function
  one_select = 'one_select',
  textfield = 'textfield',
  building_dimension_range = 'building_dimension_range',
  number_range = 'number_range',
  date_range = 'date_range',
  city_autocomplete = 'city_autocomplete',
  states_autocomplete = 'states_autocomplete',
  postal_code_combobox = 'postal_code_combobox',
  dynamic_market = 'dynamic_market',
  create_updated_by_select = 'create_updated_by_select',
  land_size_range = 'land_size_range', // should be handled in mappers to old filters and mapNewFiltersWithAdditionalKeysForApi
  autocomplete_multiple_select = 'autocomplete_multiple_select',
  sale_price_range = 'sale_price_range', // should be handled in mappers to old filters and mapNewFiltersWithAdditionalKeysForApi
  currency_range = 'currency_range',
  brokers_select = 'brokers_select',
  button_group = 'button_group',
  switch = 'switch',
  company_multiple_select = 'company_multiple_select',
  contact_names_multiple_select = 'contact_names_multiple_select',
  use_type_multiple_select = 'use_type_multiple_select',
  specialization_multiple_select = 'specialization_multiple_select',
  transaction_category_checkbox_group = 'transaction_category_checkbox_group',
  account_multiply_select = 'account_multiply_select',
  member_role_autocomplete = 'member_role_autocomplete',
  // group inputs
  in_house_group = 'in_house_group',
  land_size_with_pol_group = 'land_size_with_pol_group',
  transaction_type_group = 'transaction_type_group',
  target_completion_year_group = 'target_completion_year_group',
  pipeline_size_group = 'pipeline_size_group',
  marketing_template_autocomplete = 'marketing_template_autocomplete',
  property_use_group = 'property_use_group',
  property_type_group = 'property_type_group',
  company_name_combobox = 'company_name_combobox',
  static_set_select = 'static_set_select',
}

export enum FilterCategoryEnum {
  property_info = 'Property Details',
  site = 'Site Details',
  building = 'Building Details',
  crane = 'Crane Details',
  parking = 'Parking Details',
  rail = 'Rail Details',
  refrigeration = 'Refrigeration Details',
  doors = 'Loading & Doors Details',
  utilities = 'Utilities Details',
  company_info = 'Company Info',
  market_location = 'Property Market & Location',
  company_contact = 'Company & Contact',
  general_info = 'General Info',
  size = 'Size',
  availability_info = 'Availability Info',
  comparable_info = 'Comparable Info',
  created_edited = 'Created / Edited by',
  property_filters = 'Property Filters',
  deal_info = 'Deal Info',
  payment_details = 'Payment Details',
  referrals = 'Referrals',
  pipeline = 'Pipeline',
  company_details = 'Company Details',
  contact_details = 'Contact Details',
  office_address = 'Office Address',
  polygon_search = 'Polygon Search',
  company_filters = 'Company Filters',
  occupier_filters = 'Occupier Filters',
  availability_filters = 'Availability Filters',
  pipeline_filters = 'Pipeline Filters',
  deal_filters = 'Deal Filters',
  occupier_details = 'Occupier Details',
  contact_filters = 'Contact Filters',
  requirement_details = 'Requirement Details',
  saved_set_details = 'Saved Set Details',
  pipeline_details = 'Pipeline Details',
  referral_filters = 'Referral Filters',
  press_release_details = 'Press Release Details',
  member_details = 'Member Details',
  request_details = 'Request Details',
  presentation_details = 'Presentation Details',
  sign_details = 'Sign Details',
  marketing_campaign_details = 'Marketing Campaign Details',
  eblast_details = 'Eblast Details',
  document_details = 'Document Details',
  universal = 'Universal',
}
